import {
  SHOW_CART,
  HIDE_CART,
  TOGGLE_CART_VISIBILITY,
  RATE_SELECTED
} from "../constants/actionTypes";

export const visibleCartReducer = (state = false, action) => {
  switch (action.type) {
    case SHOW_CART:
    case HIDE_CART:
      return action.payload;

    case TOGGLE_CART_VISIBILITY:
      return !state;

    case RATE_SELECTED: {
      let result = false;
      if (!action.payload.disableCartSlideOut) {
        result = true;
      }
      return result;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/cartReducer.js